'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CentraleSansRegular = require('./CentraleSans-Regular.woff2.js');
var CentraleSansMedium = require('./CentraleSans-Medium.woff2.js');
var CentraleSansLight = require('./CentraleSans-Light.woff2.js');
var CentraleSansBold = require('./CentraleSans-Bold.woff2.js');

const centraleSansRegular = {
    fontFamily: 'Centrale Sans Regular',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontDisplay: 'swap',
    src: `
    local('Centrale Sans'),
    local('Centrale Sans Regular'),
    url(${CentraleSansRegular}) format('woff2')
  `,
};
const centraleSansMedium = {
    fontFamily: 'Centrale Sans Medium',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontDisplay: 'swap',
    src: `
    local('Centrale Sans'),
    local('Centrale Sans Medium'),
    url(${CentraleSansMedium}) format('woff2')
  `,
};
const centraleSansLight = {
    fontFamily: 'Centrale Sans Light',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontDisplay: 'swap',
    src: `
    local('Centrale Sans'),
    local('Centrale Sans Light'),
    url(${CentraleSansLight}) format('woff2')
  `,
};
const centraleSansBold = {
    fontFamily: 'Centrale Sans Bold',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontDisplay: 'swap',
    src: `
    local('Centrale Sans'),
    local('Centrale Sans Bold'),
    url(${CentraleSansBold}) format('woff2')
  `,
};

exports.centraleSansBold = centraleSansBold;
exports.centraleSansLight = centraleSansLight;
exports.centraleSansMedium = centraleSansMedium;
exports.centraleSansRegular = centraleSansRegular;
//# sourceMappingURL=fonts.js.map
